<template>
  <div>
    <b-loading
        v-model="isLoading"
        :can-cancel="false"
        :is-full-page="true"
    ></b-loading>
    <info-modal-nearmiss ref="infoModal" @onUpdateProcessingPeriods="onUpdateProcessingPeriods"></info-modal-nearmiss>
    <choose-ai-model-modal ref="chooseModel" @onSaveModel="onSaveModel"></choose-ai-model-modal>
    <create-pipeline-modal ref="pipelineModal" @onSavePipeline="onSavePipeline"></create-pipeline-modal>
    <check-materials-modal ref="checkMaterialsModal" @onProceed="onProceed"></check-materials-modal>
    <show-errors-modal ref="errorsModal"></show-errors-modal>
    <div style="background: #eeeeee;">
      <transition name="fade" mode="out-in" v-if="selectedProcessingProject === null">
        <search-box-processing ref="searchBoxProcessing" style="margin-top: 150px"
                               @onToggleSelectedProject="onToggleSelectedProject"></search-box-processing>
      </transition>
      <g-map-data-processing @onMapClicked="onMapClicked" @onMapLoaded="onMapLoaded"></g-map-data-processing>

      <div v-if="selectedProcessingProject" class="pb-6">
        <div>
          <div class="is-flex has-background-white title-box p-2">
            <div class="is-size-4 ml-5 mr-2 pt-1 pb-1 has-text-weight-bold">{{ selectedProcessingProject.project.name }}
            </div>
            <b-tooltip class="ml-1 mt-auto mb-auto mr-2" label="Refresh project" :delay="1000" type="is-dark"
                       position="is-top">
              <b-button aria-label="refresh"
                        @click="onRefreshClicked">
                <b-icon icon="refresh"></b-icon>
              </b-button>
            </b-tooltip>
            <b-tooltip class="ml-auto mt-auto mb-auto mr-2" label="Close project" :delay="1000" type="is-dark"
                       position="is-top">
              <b-button class="card-header-icon" aria-label="more options"
                        @click="closeProjectOverview">
                <b-icon icon="close"></b-icon>
              </b-button>
            </b-tooltip>
          </div>
          <div class="is-flex is-flex-direction-column p-5" style="padding-bottom: 200px !important;">
            <div class="is-size-6 mb-3 mt-2">PROJECT TASKS</div>
            <data-processing-card :progress="progress"
                                  :progress-step-one="progressStepOne"
                                  :progress-live="progressLive"
                                  v-for="dt in selectedProcessingProject.devices" :key="dt._id + dt.dataRequired" :device-data="dt"
                                  @onProcessingClick="onProcessingClick"
                                  @onChooseModelClick="onChooseModelClick"
                                  @onRunTasksClick="onRunTasksClick"
                                  @onRunTasksVehicleProcessingClick="onRunTasksVehicleProcessingClick"
                                  @onAddTasksClick="onAddTasksClick" @onRunInitialValidation="onRunInitialValidation"
                                  @onShowInitialResults="onShowInitialResults" @onShowFullResults="onShowFullResults"
                                  @onRunFullProcessing="onRunFullProcessing"
                                  @onRunPedestrianProcessing="onRunPedestrianProcessing"
                                  @onResetStep="onResetStep"
                                  @onShowError="onShowErrors"
                                  @onCreatePipeline="onCreatePipeline"
                                  @onTriggerBackProcessing="onTriggerBackProcessing"
            ></data-processing-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBoxProcessing
  from "@/modules/data-processing-tmc-module/components/search-box-processing/search-box-processing.vue";
import {mapActions, mapGetters} from "vuex";
import GMapDataProcessing
  from "@/modules/data-processing-tmc-module/components/g-map-data-processing/g-map-data-processing.vue";
import DataProcessingCard
  from "@/modules/data-processing-tmc-module/components/data-processing-card/data-processing-card.vue";
import InfoModalNearmiss
  from "@/modules/data-processing-tmc-module/components/info-modal-nearmiss/info-modal-nearmiss.vue";
import CheckMaterialsModal
  from "@/modules/data-processing-tmc-module/components/check-materials-modal/check-materials-modal.vue";
import {getVideoTimeFromLocal, getVideoTimeFromLocalToIsoString} from "@/utils/utils";
import ShowErrorsModal from "@/modules/data-processing-module/components/show-errors-modal/show-errors-modal.vue";
import ChooseAiModelModal
  from "@/modules/data-processing-tmc-module/components/choose-ai-model-modal/choose-ai-model-modal.vue";
import CreatePipelineModal
  from "@/modules/data-processing-tmc-module/components/create-pipeline-modal/create-pipeline-modal.vue";

export default {
  name: "data-processing-tmc-page",
  components: {
    CreatePipelineModal,
    ChooseAiModelModal,
    ShowErrorsModal,
    CheckMaterialsModal, InfoModalNearmiss, GMapDataProcessing, SearchBoxProcessing, DataProcessingCard
  },
  data() {
    return {
      isLoading: false,
      timer: null,
      count: 0,
      refreshSeconds: 15,
      refreshSecondStepOne: 350,
      refreshLiveProcessing:60,
      countSecondsStepOne: 0,
      countLiveProcessing: 0,
      progress: 0,
      progressStepOne: 0,
      progressLive: 0,
      refreshingData: false,
      refreshingStepOneData: false,
      refreshLiveProcessingData: false

    }
  },
  mounted() {
    console.log('O Mounted')
    this.selectCalibration(null)
    this.setSelectedProcessingDevice(null)

    this.timer = setInterval(() => {
      if (!this.refreshingData) {
        this.count++
        this.progress = this.count / this.refreshSeconds * 100
        if (this.count === this.refreshSeconds) {
          this.count = 0
          this.progress = this.count / this.refreshSeconds * 100
          this.refreshData()
        }
      }
      if (!this.refreshingStepOneData) {
        this.countSecondsStepOne++
        this.progressStepOne = this.countSecondsStepOne / this.refreshSecondStepOne * 100
        if (this.countSecondsStepOne === this.refreshSecondStepOne) {
          this.countSecondsStepOne = 0
          this.progressStepOne = this.countSecondsStepOne / this.refreshSecondStepOne * 100
          this.refreshStepOneData()
        }
      }

      if (!this.refreshLiveProcessingData) {
        this.countLiveProcessing++
        this.progressLive = this.countLiveProcessing / this.refreshLiveProcessing * 100
        if ( this.countLiveProcessing === this.refreshLiveProcessing) {
          this.countLiveProcessing = 0
          this.progressLive = this.countLiveProcessing / this.refreshLiveProcessing * 100
          this.refreshLiveData()
        }
      }

    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
    this.count = 0
  },
  methods: {
    ...mapActions({
      setSelectedProcessingProject: 'dataProcessingTmcModule/setTmcSelectedProcessingProject',
      selectCalibration: 'dataProcessingTmcModule/selectTmcCalibration',
      setSelectedProcessingDevice: 'dataProcessingTmcModule/setTmcSelectedProcessingDevice',
      createTasks: 'dataProcessingTmcModule/createTmcTasks',
      pushTasksToSqs: 'dataProcessingTmcModule/pushTmcTasksToSqs',
      runInitialValidation: 'dataProcessingTmcModule/runTmcInitialValidation',
      getNearMissValidation: 'dataProcessingTmcModule/getNearMissValidation',
      checkVideoPathTasks: 'dataProcessingTmcModule/checkTmcVideoPathTasks',
      refreshLiveTasks: 'dataProcessingTmcModule/refreshTmcLiveTasks',
      runFullValidation: 'dataProcessingTmcModule/runTmcFullValidation',
      runPedestrianProcessing: 'dataProcessingTmcModule/runTmcPedestrianProcessing',
      resetProcessingStep: 'dataProcessingTmcModule/resetTmcProcessingStep',
      setRefreshingDevices: 'dataProcessingTmcModule/setTmcRefreshingDevices',
      setVideoPathRefreshingDevices: 'dataProcessingTmcModule/setTmcVideoPathRefreshingDevices',
      setLiveRefreshingDevices: 'dataProcessingTmcModule/setTmcLiveRefreshingDevices',
      updateProcessingPeriods: 'dataProcessingTmcModule/updateProcessingPeriods',
      savePipeline: 'dataProcessingTmcModule/savePipeline',
      triggerBackProcessing: 'dataProcessingTmcModule/triggerBackProcessing',
    }),
    onShowErrors(errors) {
      console.log('On show errorssss', errors)
      this.$refs.errorsModal.show(true, errors)
    },
    async onRefreshClicked() {
      this.isLoading = true
      await this.setSelectedProcessingProject(this.selectedProcessingProject.project)
      this.isLoading = false
      // console.log("PROJECT: ", this.selectedProcessingProject.project)
    },
    async onToggleSelectedProject(project) {
      console.log('Selected project: toggle', project)
      if (project === null) {
        await this.setSelectedProcessingProject(null)
      } else {
        this.isLoading = true
        await this.setSelectedProcessingProject(project)
        this.isLoading = false
      }
    },
    refreshData() {
      console.log('On refresh data')
      this.refreshingData = true
      let refreshDataDevices = this.getRefreshingDevices
      console.log('Refreshing 2-4 devices: ', refreshDataDevices)
      this.setRefreshingDevices(refreshDataDevices.deviceRefresh)

      setTimeout(() => {
        this.refreshingData = false
      }, 5000)

      if (refreshDataDevices.doRefresh) {
        console.log('Run Refresh', refreshDataDevices)
        this.getNearMissValidation(this.selectedProcessingProject.project)
      }

    },
    refreshStepOneData() {
      console.log('On refresh step one data')
      this.refreshingStepOneData = true
      let refreshVehiclePathDevices = this.getRefreshVehiclePathDevices
      console.log('Refreshing path devices: ', refreshVehiclePathDevices)
      this.setVideoPathRefreshingDevices(refreshVehiclePathDevices.deviceRefresh)

      setTimeout(() => {
        this.refreshingStepOneData = false
      }, 5000)

      if (refreshVehiclePathDevices.doRefresh) {
        this.checkVideoPathTasks(this.selectedProcessingProject.project)
      }
    },
    refreshLiveData() {
      console.log('On refresh live processing')
      this.refreshLiveProcessingData = true
      let refreshLiveDevices = this.getRefreshLiveDevices
      console.log('Refreshing live devices: ', refreshLiveDevices)
      this.setLiveRefreshingDevices(refreshLiveDevices.deviceRefresh)

      setTimeout(() => {
        this.refreshLiveProcessingData = false
      }, 5000)

      if (refreshLiveDevices.doRefresh) {
        this.refreshLiveTasks(this.selectedProcessingProject.project)
      }
    },
    async onAddTasksClick(deviceData) {

      this.isLoading = true

      let payload = {
        dataDeviceId: deviceData._id,
        saveTasks: false
      }

      let response = await this.createTasks(payload)

      if (response instanceof Error) {
        //this.showToast(response.message, 'is-danger')
        this.showSnackBar(`Error: ${response.message}`, 'is-danger')
      } else {
        //this.show(false, false)
        console.log('Create tasks response: ', response)
        if (response.summaryCharts) {
          let chartsData = JSON.parse(JSON.stringify(response.summaryCharts))
          chartsData.forEach(data => {
            data.x = data.x.map(x => getVideoTimeFromLocalToIsoString(x))
          })

          let data = {
            _id: deviceData._id,
            siteName: deviceData.site.name,
            name: deviceData.name,
            chartsData: chartsData
          }
          this.$refs.checkMaterialsModal.show(true, data)
        }
      }

      this.isLoading = false
    },
    async onProceed(dt) {
      let data = JSON.parse(JSON.stringify(dt))
      this.$refs.checkMaterialsModal.show(false, null)
      console.log('On proceed data: ', data)


      this.isLoading = true

      let payload = {
        dataDeviceId: dt._id,
        saveTasks: true
      }

      let response = await this.createTasks(payload)

      if (response instanceof Error) {
        //this.showToast(response.message, 'is-danger')
        this.showSnackBar(`Error: ${response.message}`, 'is-danger')
      } else {
        this.showToast('Tasks successfully created', 'is-success')
        console.log('Create tasks response 1: ', response)
      }

      this.isLoading = false

    },
    async onUpdateProcessingPeriods(data) {

      let payload = JSON.parse(JSON.stringify(data))

      console.log('OnUpdateProcessingPeriods payload: ', payload)

      this.$refs.infoModal.show(false)

      this.isLoading = true
      let response = await this.updateProcessingPeriods(payload)

      if (response instanceof Error) {
        this.showSnackBar(`Error: ${response.message}`, 'is-danger')
      } else if (response === true) {
        await this.setSelectedProcessingProject(this.selectedProcessingProject.project)
        this.showToast('Processing periods successfully updated', 'is-success')
      }

      this.isLoading = false
    },
    async onSaveModel(data) {
      let payload = JSON.parse(JSON.stringify(data))
      console.log('On save model clicked payload: ', payload)

      let sendPayload = {
        modelType: 'ai',
        dataDeviceId: payload.dataDeviceId,
        functionName: payload.model.functionName
      }

      Object.keys(payload.model).forEach(key => {
        if (payload.model[key] !== undefined && payload.model[key] !== null) {
          sendPayload[key] = payload.model[key];
        }
      });

      console.log('Send payload: ', sendPayload)

      this.$refs.chooseModel.show(false)

      this.isLoading = true
      let response = await this.createTasks(sendPayload)
      this.handleResponseCreateTasks(response)
      this.isLoading = false
    },
    async onSavePipeline(data) {
      let payload = JSON.parse(JSON.stringify(data))
      console.log('On save pipeline clicked payload: ', payload)
      let sendPayload = {
        dataDeviceId: payload.dataDeviceId,
        dataRequired: {
          ai: payload.pipeline.ai,
          data: Array.isArray(payload.pipeline.data) ? payload.pipeline.data : [payload.pipeline.data],
          events: payload.pipeline.events,
          rules: payload.pipeline.rules
        },

      }
      console.log('Send payload: ', sendPayload)

      this.$refs.pipelineModal.show(false)
      let trafficLightCalibrationExists = true
      if(this.selectedProcessingProject && this.selectedProcessingProject.devices && payload.pipeline.ai.includes('traffic-light')){
        trafficLightCalibrationExists = false
        //find device for pipeline
        const deviceIndex = this.selectedProcessingProject.devices.findIndex(device => device._id === payload.dataDeviceId)
        if(deviceIndex !== -1){
          const device = this.selectedProcessingProject.devices[deviceIndex]
          console.log('Create live pipeline for device: ', device)

          if(device.videoCalibrations && device.videoCalibrations.length > 0){
            device.videoCalibrations.forEach(calibration =>{
              if(calibration.status === 'active' && calibration.calibration.trafficLightPolygons && calibration.calibration.trafficLightPolygons.length > 0){
                trafficLightCalibrationExists = true
              }
            })
          }
        }

        if(!trafficLightCalibrationExists){
          this.showSnackBar(`Existing active Video Configs do not have the settings for the ai traffic-light model. Please set the Traffic Light Polygons in the video calibration first.`, 'is-danger')
          return
        }

      }

      this.isLoading = true
      let response = await this.savePipeline(sendPayload)
      if (response instanceof Error) {
        this.showSnackBar(`Error: ${response.message}`, 'is-danger')
      } else {
        this.showToast('Processing pipeline successfully updated', 'is-success')
      }
      this.isLoading = false
    },
    handleResponseCreateTasks(response) {

      let message = ''
      let isError = false

      if (response instanceof Error) {
        message = response.message
        isError = true
      } else if (response.type && response.type === 'task_summary' && response.summaryCharts && response.summaryCharts.errors > 0) {
        isError = true
        if (response.summaryCharts.errorDetails && response.summaryCharts.errorDetails.length > 0) {
          response.summaryCharts.errorDetails.forEach(errorMsg => {
            message += `${errorMsg}\n`
          })
        } else {
          message = 'Create tasks errors: ' + response.summaryCharts.errors
        }
        console.log('Create tasks response 1: ', response)
      } else if (response.response && response.response.type && response.response.type === 'task_summary' && response.response.summaryCharts && response.response.summaryCharts.errors > 0) {
        isError = true
        if (response.response.summaryCharts.errorDetails && response.response.summaryCharts.errorDetails.length > 0) {
          response.response.summaryCharts.errorDetails.forEach(errorMsg => {
            message += `${errorMsg}\n`
          })
        } else {
          message = 'Create tasks errors: ' + response.response.summaryCharts.errors
        }
        console.log('Create tasks response 1: ', response)
      } else if (response.type && response.type === 'task_summary' && response.summaryCharts && response.summaryCharts.errors === 0) {
        message = `Tasks successfully created.
        Total video processed: ${response.summaryCharts.totalVideosProcessed}
        Task created: ${response.summaryCharts.tasksCreated}
        Total skipped: ${response.summaryCharts.tasksSkipped}
        Errors: ${response.summaryCharts.errors}
        `
      } else if (response.response && response.response.type && response.response.type === 'task_summary' && response.response.summaryCharts && response.response.summaryCharts.errors === 0) {
        message = `
        Tasks successfully created.
        Total video processed: ${response.response.summaryCharts.totalVideosProcessed}
        Task created: ${response.response.summaryCharts.tasksCreated}
        Total skipped: ${response.response.summaryCharts.tasksSkipped}
        Errors: ${response.response.summaryCharts.errors}
        `
      } else if (response.response && response.response.type && response.response.type === 'task_summary' && response.response.summaryCharts && response.response.summaryCharts.tasksCreated) {
        message = `${response.response.summaryCharts.tasksCreated} tasks successfully created.`
      } else if (response.response && response.response.type && response.response.type === 'task_summary' && response.response.summaryCharts === null && response.response.taskCount) {
        message = `${response.response.taskCount} tasks successfully created.`
      }

      this.showSnackBar(`${message}`, isError ? 'is-danger' : 'is-success')
    },
    async onRunTasksClick(dataDevice) {
      this.isLoading = true

      let payload = {
        data: {
          dataDeviceId: dataDevice._id,
          taskType: 'video_path_tracking'
        },
        selectedProject: this.selectedProcessingProject.project
      }

      let response = await this.pushTasksToSqs(payload)

      if (response instanceof Error) {
        this.showToast(response.message, 'is-danger')
      } else {
        let message = 'Tasks successfully pushed to processing queue. Info: '
        if (response.pushToSqsMessage && response.pushToSqsMessage.message) {
          message += response.pushToSqsMessage.message
        } else {
          message += 'No Info'
        }
        this.showToast(message, 'is-success')
      }

      this.isLoading = false
    },
    async onRunTasksVehicleProcessingClick(dataDevice) {
      this.isLoading = true

      let payload = {
        data: {
          dataDeviceId: dataDevice._id,
          taskType: 'video_process_object_path'
        },
        selectedProject: this.selectedProcessingProject.project
      }

      let response = await this.pushTasksToSqs(payload)

      if (response instanceof Error) {
        this.showToast(response.message, 'is-danger')
      } else {
        let message = 'Tasks successfully pushed to processing queue. Info: '
        if (response.pushToSqsMessage && response.pushToSqsMessage.message) {
          message += response.pushToSqsMessage.message
        } else {
          message += 'No Info'
        }
        this.showToast(message, 'is-success')
      }

      this.isLoading = false
    },
    onMapClicked() {
      console.log('On map clicked')
      if (this.$refs.searchBoxProcessing) {
        this.$refs.searchBoxProcessing.onClickedOutside()
      }
      console.log('Selected Processing Project: ', this.selectedProcessingProject)
    },
    onMapLoaded() {
      console.log('On map loaded')
    },
    closeProjectOverview() {
      this.setSelectedProcessingProject(null)
    },
    openCalibrationPage() {
      this.$router.push('/video-calibration')
    },
    onProcessingClick(data) {
      this.$refs.infoModal.show(true, data, 'Processing Period/s', 'periods')
    },
    onChooseModelClick(data) {
      this.$refs.chooseModel.show(true, data, 'AI Model')
    },
    async onRunInitialValidation(dataDevice) {
      console.log('Run vehicles processing: ', dataDevice)

      let sendPayload = {
        modelType: 'data_processing',
        dataDeviceId: dataDevice._id,
      }


      console.log('Send payload: ', sendPayload)

      this.isLoading = true
      let response = await this.createTasks(sendPayload)
      this.handleResponseCreateTasks(response)
      this.isLoading = false
    },
    async onRunFullProcessing(dataDevice) {
      console.log('On run full processing: ', dataDevice)
      this.isLoading = true
      //reset timer count
      this.count = 0
      let payload = {
        dataDeviceId: dataDevice._id,
        selectedProject: this.selectedProcessingProject.project
      }
      console.log('Payload: ', payload)

      let response = await this.runFullValidation(payload)

      if (response instanceof Error) {
        //this.showToast(response.message, 'is-danger')
        this.showSnackBar(`Error: ${response.message}`, 'is-danger')
      } else {
        this.showToast('Full Data Processing successfully started', 'is-success')
      }

      this.isLoading = false
    },
    async onRunPedestrianProcessing(dataDevice) {
      console.log('Run pedestrian processing: ', dataDevice)
      this.isLoading = true
      //reset timer count
      this.count = 0
      let payload = {
        dataDeviceId: dataDevice._id,
        selectedProject: this.selectedProcessingProject.project
      }
      console.log('Payload: ', payload)

      let response = await this.runPedestrianProcessing(payload)

      if (response instanceof Error) {
        //this.showToast(response.message, 'is-danger')
        this.showSnackBar(`Error: ${response.message}`, 'is-danger')
        this.isLoading = false
      } else {
        this.showToast('Pedestrian Processing successfully started', 'is-success')
        this.isLoading = false
      }
    },
    onShowInitialResults(dataDevice) {
      console.log('On Show initial results:', dataDevice)
      this.setSelectedProcessingDevice(dataDevice)


      const params = {
        projectId: this.selectedProcessingProject.project._id,
        dataDeviceId: dataDevice._id,
        dataType: 'initial'
      }

      if (this.selectedDevice.initialValidationData && this.selectedDevice.initialValidationData.validationChart) {
        this.$router.push({name: 'auto-validation-review', params: params})
      } else {
        this.showToast('Initial charts not exists', 'is-danger')
      }
    },
    onShowFullResults(dataDevice) {
      console.log('On Show initial results:', dataDevice)
      this.setSelectedProcessingDevice(dataDevice)


      const params = {
        projectId: this.selectedProcessingProject.project._id,
        dataDeviceId: dataDevice._id,
      }

      //this.$router.push({name: 'qa', params: params})
      const routeData = this.$router.resolve({name: 'qa', params: params});
      window.open(routeData.href, '_blank');
    },
    showToast(message, type) {
      this.$buefy.toast.open({
        message: message,
        duration: 3000,
        type: type
      })
    },
    showSnackBar(message, type) {
      this.$buefy.snackbar.open({
        message: message,
        type: type,
        position: 'is-top',
        actionText: 'Ok',
        indefinite: true,
        customClass: 'my-custom-snackbar'
      })
    },
    async onResetStep(data) {
      console.log('Reset step: ', data)
      this.isLoading = true
      //reset timer count
      this.count = 0
      let response = await this.resetProcessingStep(data)

      if (response instanceof Error) {
        this.showToast(response.message, 'is-danger')
        this.isLoading = false
      } else {
        this.showToast('Reset Success', 'is-success')
        this.isLoading = false
      }
    },
    async onCreatePipeline(data) {
      console.log('On create pipeline: ', data)
      if(data.processingPeriods && data.processingPeriods.length > 0){
        this.$refs.pipelineModal.show(true, data, 'Continuous processing pipeline')
      }else{
        this.showToast('PLease define processing periods first', 'is-danger')
      }
    },
    async onTriggerBackProcessing(data) {
      console.log('On trigger back processing: ', data)
      let payload = {
        lambdaName: 'back_processing_for_live_pipeline',
        payload: {
          dataDeviceId: data._id
        }
      }

      console.log('On trigger back processing payload: ', payload)
      this.isLoading = true
      let response = await this.triggerBackProcessing(payload)

      if (response instanceof Error) {
        this.showToast(response.message, 'is-danger')
        this.isLoading = false
      } else {
        if(response.type && response.type === 'success'){
          let message = response.message
          if(response.summary){
            message += `\nTotal videos: ${response.summary.totalVideos}`
            message += `\nProcessed Successfully: ${response.summary.processedSuccessfully}`
            message += `\nFailed: ${response.summary.failed}`
            message += `\nStart date: ${response.summary.startDate}`
          }
          this.showSnackBar(`${message}`, 'is-success')
        }else if(response.type && response.type === 'error'){
          this.showToast(response.message, 'is-danger')
        }

        this.isLoading = false
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedProcessingProject: 'dataProcessingTmcModule/getTmcSelectedProcessingProject',
      selectedDevice: 'dataProcessingTmcModule/getTmcSelectedProcessingDevice'
    }),
    getRefreshingDevices() {
      let refreshData = {doRefresh: false, deviceRefresh: []}
      if (this.selectedProcessingProject && this.selectedProcessingProject.devices && this.selectedProcessingProject.devices.length > 0) {
        for (let i = 0; i < this.selectedProcessingProject.devices.length; i++) {
          let refresh = {id: this.selectedProcessingProject.devices[i]._id, refresh: false}
          let tasks

          if (this.selectedProcessingProject.devices[i].tasks) {
            tasks = this.selectedProcessingProject.devices[i].tasks
          }
          let fullTasks
          let fullCharts = null
          if (this.selectedProcessingProject.devices[i].initialValidationData && this.selectedProcessingProject.devices[i].initialValidationData.fullTasks) {
            fullTasks = this.selectedProcessingProject.devices[i].initialValidationData.fullTasks
          }
          if (this.selectedProcessingProject.devices[i].initialValidationData && this.selectedProcessingProject.devices[i].initialValidationData.validationChart) {
            fullCharts = this.selectedProcessingProject.devices[i].initialValidationData.fullChart
          }
          if (fullTasks && ((fullTasks.status !== 'COMPLETED' && fullTasks.status !== 'FAILED') /*|| fullCharts === null || fullCharts.version !== fullTasks.version*/)) {
            refresh.refresh = true
            refreshData.doRefresh = true
            console.log('3')
          }

          refreshData.deviceRefresh.push(refresh)
        }
      }
      return refreshData
    },
    getRefreshVehiclePathDevices() {
      let refreshData = {doRefresh: false, deviceRefresh: []}
      if (this.selectedProcessingProject && this.selectedProcessingProject.devices && this.selectedProcessingProject.devices.length > 0) {
        for (let i = 0; i < this.selectedProcessingProject.devices.length; i++) {
          let refresh = {id: this.selectedProcessingProject.devices[i]._id, refresh: false}
          let tasks

          if (this.selectedProcessingProject.devices[i].tasks) {
            tasks = this.selectedProcessingProject.devices[i].tasks
          }
          if (tasks && tasks.status !== 'COMPLETED' && tasks.status !== 'FAILED' && tasks !== 'CREATED') {
            refresh.refresh = true
            console.log('1', this.selectedProcessingProject.devices[i])
            refreshData.doRefresh = true
          }
          refreshData.deviceRefresh.push(refresh)
        }
      }
      return refreshData
    },
    getRefreshLiveDevices() {
      let refreshData = {doRefresh: false, deviceRefresh: []}
      if (this.selectedProcessingProject && this.selectedProcessingProject.devices && this.selectedProcessingProject.devices.length > 0) {
        for (let i = 0; i < this.selectedProcessingProject.devices.length; i++) {
          let refresh = {id: this.selectedProcessingProject.devices[i]._id, refresh: false}
          if (this.selectedProcessingProject.devices[i].dataRequired) {
            refresh.refresh = true
            refreshData.doRefresh = true
          }
          refreshData.deviceRefresh.push(refresh)
        }
      }
      return refreshData
    }
  }
}
</script>

<style scoped>
.title-box {
  background-color: hsl(0deg, 0%, 100%);
  border-radius: 0;
  box-shadow: 0 0.125em 0.5em -0.125em rgb(10 10 10 / 10%), 0 0px 0 1px rgb(10 10 10 / 2%);
  color: hsl(0deg, 0%, 29%);
  display: block;
  padding: 1.25rem;
}

</style>